const en = {
  settings: 'Settings',
  demo: {
    title: `English`,
    introduction: `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.`,
  },
  docs: {
    hi: `Hi`,
    description: `Need help? \n Please check our docs.`,
    documentation: `documentation`,
  },
  dont_have_an_account: 'Don’t have an account ?',
  hi_welcome_back: 'Hi, Welcome Back',
  sign_in_to: 'Sign in to',
  enter_your_details_below: 'Enter your details below.',
  get_started: 'Get started',
  email_address: 'Email Address',
  address: 'Address',
  new_coming_soon: 'New Gateways are coming soon',
  city: 'City',
  quick_links: 'Quick Links',
  contact_now: 'Contact Now !',
  state: 'State',
  password: 'Password',
  zip: 'Zip',
  forgot_password: 'Forgot password?',
  country: 'Country',
  select_country: 'Select Country',
  login: 'Login',
  customer_specific: 'Customer Specific',
  email_must_be_a_valid_email_address: 'Invalid email',
  email_is_required: 'Email is required',
  city_is_required: 'City is Required',
  state_is_required: 'State is required',
  zip_is_required: 'Zip is required',
  password_is_required: 'Password is required',
  already_have_an_account: 'Already have an account?',
  register_with_mwbapps_heading:
    'Register with MWBApps to get Payments smoothly from your customer.',
  get_started_absolutely_free: 'Get started absolutely free.',
  seven_days_trail_no_credit_card:
    '7 days free trial. No credit card required,',
  by_registering_i_agree_to_mwbapps: 'By registering, I agree to MWBApps',
  terms_of_service: 'Terms of Service',
  and: 'and',
  privacy_policy: 'Privacy Policy',
  passwords_must_match: 'Passwords must match',
  resend_verification: 'Resend Verification',
  login_here: 'Login here',
  new_password: 'New Password',
  confirm_password: 'Confirm Password',
  save_password: 'Save Password',
  invalid_token_verification: 'Invalid Token Verification',
  confirm_new_password: 'Confirm New Password',
  forgot_your_password: 'Forgot your password?',
  update_form: 'Update Form',
  publish_form: 'Publish Form',
  please_enter_email_to_get_link:
    'Please enter the email address associated with your account. We will email you a link to reset your password.',
  back_to_login: 'Back to Login',
  password_change_successfully: 'Password changed successfully',
  back_to_register: 'Back to register',
  request_sent_sucessfully: 'Request sent successfully',
  sent_confirmation_to: 'We have sent a confirmation email to',
  please_check_your_email: 'Please check your email.',
  back: 'Back',
  email_verified_successfully: 'Email Verified Successfully',
  go_to_login: 'Go to Login',
  emailed_a_link_to_verify: 'We have emailed a link to verify your email',
  dont_have_email: 'Don’t have a mail?',
  resend_email: 'Resend email',
  email_not_verified_try_again: 'Email Not Verified Try Again',
  recheck_your_email_or_register_again:
    'There is something wrong please re-click your email link or register again from login.',
  code_is_required: 'Code is required',
  code: 'code',
  comments: 'Comments',
  verify: 'Verify',
  verification_link_resent: 'Verification link resent, Please check Mailbox.',
  resend: 'Resend',
  register: 'Register',
  didnt_gateway: "Didn't find your gateway ?",
  single_document: 'Documentation',
  stripe_and_paypal_to_be_comming_soon:
    'Stripe and Paypal are next gateways to be integrated soon',
  id: 'ID:',
  connect_with_us: 'Still need help ? Connect with us',
  need_help: 'Need Help',
  logout: 'Logout',
  connect_portals: 'Connect Portals',
  choose_listed_portals:
    'Choose from any of the listed HubSpot Portals. If your portal is not listed, to create new portal go to HubSpot',
  add_new_portal: 'Add New Portal',
  no_portal_found: 'No Portal Found',
  no_portal_added_yet_click_add_new_portal_btn:
    'No Portal has been added yet. You can add new portals by clicking on add new portal button',
  portal_listing: 'Portal Listing',
  support: 'Support',
  hubspot_portals: 'Hubspot Portals',
  mailed_six_digit_code:
    'We have emailed a 6-digit confirmation code to acb@domain, please enter the code in below box to verify your email.',
  resend_code: 'Resend code',
  active: 'Active',
  inActive: 'In-active',
  dashboard: 'Dashboard',
  tutorial: 'Tutorial',
  schedule_meeting:
    'Schedule a 1-on-1 meeting with our implementation expert to help you integrate MWBApps',
  schedule_now: 'Schedule Now',
  schedule_a_meeting: 'Schedule a meeting',
  active_gateways: 'Active Gateways',
  welcome: 'Welcome',
  name: 'Name',
  created: 'Created At',
  type: 'Type',
  action: 'Action',
  form_listing: 'Form Listing',
  forms: 'Forms',
  form: 'Form',
  form_list: 'Form List',
  create_new_form: 'Create New Form',
  name_is_required: 'Name is required',
  country_is_required: 'Country is required',
  amount_does_not_match_with_plan:
    'Amount does not match with the selected plan.',
  phone_number_not_valid: 'Phone Number Not Valid',
  hubspot_form_is_required: 'HubSpot Form is required',
  mode_is_required: 'Mode is required',
  fill_valid_amount: 'Fill Valid Amount',
  select_currency: 'Select Currency',
  payment_type: 'Payment Type',
  payment_type_is_required: 'Payment Type is required',
  select_atleast_one_gateway: 'Select atleast 1 Gateway',
  edit: 'Edit',
  form_settings: 'Form Settings',
  payment_settings: 'Payment Settings',
  payment_method: 'Payment Method',
  delete_form: 'Delete Form',
  publish_the_form_to_load_preview: 'Please publish the form to load preview',
  please_fix_errors: 'Please Fix Errors.',
  form_name: 'Form Name',
  select_hubspot_form: 'Select Hubspot Form',
  enter_amount: 'Enter Amount',
  single: 'Single',
  enable_test_mode: 'Enable Test Mode',
  no_gateway_found: 'No Gateway Found',
  currency: 'Currency',
  form_submission: 'Form Submission',
  form_submission_listing: 'Form Submission Listing',
  view_in_hubspot: 'View in HubSpot',
  status: 'Status',
  date: 'Date',
  amount: 'Amount',
  transaction: 'Transaction',
  transaction_listing: 'Transaction Listing',
  success: 'Success',
  failed: 'Failed',
  payment_gateway: 'Payment Gateway',
  gateways: 'Gateways',
  manage: 'Manage',
  setup: 'Setup',
  gatway_listing: 'Gateway Listing',
  setup_instructions: 'Setup Instructions',
  test_merchant_id_is_required: 'Test Merchant Id is required',
  test_store_id_is_required: 'Test Store Id is required',
  test_public_key_is_required: 'Test Public key Id is required',
  test_private_key_file_is_required: 'Test Private Key File is required',
  live_merchant_id_is_required: 'Live Merchant Id is required',
  live_store_id_is_required: 'Live Store Id is required',
  live_public_key_id_is_required: 'Live Public key Id is required',
  live_private_key_file_is_required: 'Live Private Key File is required',
  payment_region_is_required: 'Payment Region is required',
  payment_currency_is_required: 'Payment Currency is required',
  button_language_is_required: 'Button Language is required',
  button_color_is_required: 'Button Color is required',
  product_type_is_required: 'Product Type is required',
  test_account_details: 'Test Account Details',
  merchant_id: 'Merchant Id',
  account_single: 'Account',
  store_id: 'Store Id',
  public_key_id: 'Public Key Id',
  test_private_key_file: 'Test Private Key File',
  live_account_details: 'Live Account Details',
  live_private_key_file: 'Live Private key File',
  other_account_details: 'Other Account Details',
  payment_region: 'Payment Region',
  payment_currency: 'Payment Currency',
  button_language: 'Button Language',
  button_color: 'Button Color',
  product_type: 'Product Type',
  activate_gateway: 'Activate Gateway',
  test_api_key_is_required: 'Test Api Key is required',
  test_merchant_account_is_required: 'Test Merchant Account is required',
  test_client_key_is_required: 'Test Client Key is required',
  live_api_key_is_required: 'Live Api Key is required',
  live_merchant_account_name_is_required:
    'Live Merchant Account Name is required',
  live_client_key_is_required: 'Live Client Key is required',
  live_end_point_prefix_is_required: 'Live Endpoint Prefix is required',
  test_api_key: 'Test Api Key',
  test_merchant_account_name: 'Test Merchant Account Name',
  test_client_key: 'Test Client Key',
  live_api_key: 'Live Api Key',
  live_merchant_account_name: 'Live Merchant Account Name',
  live_client_key: 'Live Client Key',
  live_endpoint_prefix: 'Live Endpoint Prefix',
  issue_payment_failed: 'There was an issue! Payment Failed.',
  issue_coupon_creation_failed: 'There was an issue! Coupon Creation Failed.',
  payment_successful_redirect_to_dashboard:
    'Payment Successfull.Redirecting to Accounts Billing...',
  coupon_successful_created: 'Coupon Successfully Created',
  payment: 'Payment',
  billing_details: 'Billing Details',
  full_name: 'Full Name',
  phone: 'Phone',
  payment_info: 'Payment Info',
  plan: 'Plan',
  month: 'Month',
  saving_per_month: 'Saving $24 a month',
  order_summary: 'Order Summary',
  sub_total: 'Sub Total',
  total: 'Total',
  complete_payment: 'Complete Payment',
  plan_subscribed: 'Plan Subscribed',
  you_have_been_subscribed_to: 'You have been Subscribed to',
  your_subscription_will_end_on: 'your subscription will end on',
  your_next_payment_date_is: 'Your Next Payment Due Date is',
  cancel_subscription: 'Cancel Subscription',
  something_went_wrong_contact_admin:
    'Something went wrong.Please Contact Admistrator',
  delete: 'Delete',
  change_password: 'Change password',
  your_new_password_different_from_prev_password:
    'Your new password must be different from previous used passwords. Must contain at least 8 characters.',
  back_to_dashboard: 'Back To Dashboard',
  manage_hubspot_form: 'Manage Hubspot Form',
  sorry_page_not_found: 'Sorry, page not found!',
  sorry_could_not_find_page:
    "Sorry, we couldn't find the page you're looking for. Maybe you mistyped the URL? Be sure to check your spelling.",
  go_to_home: 'Go to Home',
  first_name: 'First Name',
  last_name: 'Last Name',
  phone_number: 'Phone Number',
  state_region: 'State/Region',
  save_details: 'Save Details',
  your_form_is_published: 'Your form is published',
  form_preview: 'Form Preview',
  embed_code: 'Embed Code',
  add_your_hubspot_portal: 'Add your HubSpot Portal(s) to the app',
  select_the_portal_you_want_to_connect:
    'Select the portal you want to connect',
  setup_payment_gateways: 'Setup payment gateways',
  create_configure_forms: 'Create, Configure and Publish the form(s)',
  comming_soon: 'Coming Soon',
  page_not_found: '404 Page Not Found',
  billing: 'billing',
  user_accounts: 'User Accounts',
  ecommerce: `e-commerce`,
  product_list: 'Product List',
  reset_password: 'Reset Password',
  send_mail: 'Send Email',
  connect_with_hubspot:
    'Connect your HubSpot Account so we can connect with your portal',
  connect_my_hubspot_account: 'Connect My Hubspot Account',
  skip_this_step: 'Skip this step',
  connect_with_hubspot_account: 'Connect your Hubspot Account',
  fill_the_required_fields: 'Fill the required Fields',
  old_password_is_required: 'Old Password is required',
  password_must_be_eight_char: 'Password must be at least 8 characters',
  new_password_is_required: 'New Password is required',
  save: 'Save',
  old_password: 'Old Password',
  first_name_is_required: 'First Name is required',
  last_name_is_required: 'Last Name is required',
  phone_must_contain_10_digit: 'Phone Number must contain 10 digits',
  address_is_required: 'Address is required',
  discount_type_is_required: 'Discount Type is required',
  discount_amount_is_required: 'Discount amount is required',
  zipcode_is_required: 'Zipcode is required',
  no: 'No',
  coupon_created: 'Coupon Created',
  success_rate: 'Success Rate',
  has_been_found: 'has been found.',
  will_expire_today: 'will expire Today',
  will_expire_on: 'will expire on',
  your_plan: 'Your Plan',
  test_client_id: 'Test Client ID',
  live_client_id: 'Live Client ID',
  button_layout: 'Button Layout',
  button_shape: 'Button Shape',
  button_label: 'Button Label',
  live_client_id_is_required: 'Live Client Id is required.',
  test_client_id_is_required: 'Test Client Id is required.',
  button_layout_is_required: 'Button Layout is required.',
  button_shape_is_required: 'Button Shape is required.',
  button_label_is_required: 'Button Label is required.',
  test_publishable_key_is_required: 'Test Publishable Key is required',
  test_publishable_key: 'Test Publishable Key',
  test_secret_key_is_required: 'Test Secret Key is required',
  test_secret_key: 'Test Secret key',
  live_publishable_key_is_required: 'Live Publishable Key is required',
  live_publishable_key: 'Live Publishable Key',
  live_secret_key_is_required: 'Live Secret Key is required',
  live_secret_key: 'Live Secret key',
  feel_free_to_contact_us_anytime: 'Feel free to contact us anytime',
  general: `general`,
  your_trial: 'Your Trial',
  activate: 'Activate',
  disable: 'Disable',
  store_listing: 'Store Listing',
  store_url: 'Store Url',
  coupon_name: 'Coupon Name',
  discount_type: 'Discount Type',
  discount_amount: 'Discount Amount',
  discount_value: 'Discount Value',
  coupons: 'Coupons',
  coupon_expiry: 'Coupon Expiry',
  stores: 'Stores',
  create_new_coupon: 'Create New Coupon',
  create_new_coupon_rule: 'Create New Coupon Rule',
  create_new_store: 'Create New Store',
  app_listing: 'App Listing',
  create_store: 'Create Store',
  add_new_store: 'ADD STORE',
  home: 'Home',
  select: 'Select',
  loading: 'Loading',
  coming_soon: 'Coming Soon',
  app: `app`,
  user: `user`,
  list: `list`,
  shop: `shop`,
  blog: `blog`,
  post: `post`,
  mail: `mail`,
  chat: `chat`,
  cards: `cards`,
  posts: `posts`,
  create: `Create`,
  kanban: `kanban`,
  banking: `banking`,
  booking: `booking`,
  profile: `profile`,
  account: `account`,
  product: `product`,
  invoice: `invoice`,
  details: `details`,
  checkout: `Checkout`,
  calendar: `calendar`,
  analytics: `analytics`,
  management: `management`,
  menu_level_1: `menu level 1`,
  menu_level_2: `menu level 2`,
  menu_level_3: `menu level 3`,
  item_disabled: `item disabled`,
  item_label: `item label`,
  item_caption: `item caption`,
  description: `description`,
  other_cases: `other cases`,
  item_by_roles: `item by roles`,
  only_admin_can_see_this_item: `Only admin can see this item`,
  you_have_only: 'You have only',
  left_in_trial: 'days left of your trial period',
  update: 'Update',
  one_currency_gateway:
    'You can select payment gateways with one currency type',
  store_source: 'Store Source',
  coupon_source: 'Coupon Source',
  coupon_snippet: 'Coupon Snippet',
  prefix: 'Prefix',
  merge_fields: 'Merge Fields',
  random_characters: 'Random Characters',
  suffix: 'Suffix',
  format: 'Format',
  flat_discount: 'Flat Discount',
  percent_discount: 'Percent Discount',
  coupon_usage_limit: 'Coupon Usage Limit',
  custom_name_property: 'HubSpot Custom Property (Internal Name)',
  custom_property_helpText: 'HubSpot custom property for coupon code',
  created_coupon_rule: 'Created coupon will expire after provided no. of days',
  exclude_sale_items: 'Exclude sale items',
  allow_free_shipping: 'Allow free shipping',
  individual_use_only: 'Individual use only',
  usage_limit: 'Usage Limit',
  source_url: 'Source URL',
  select_brand: 'Select Brand',
  coupon_source_required: 'Coupon Source is required',
  valid_coupon_snippet_required: 'Valid Coupon Snippet is required',
  select_product: 'Select Product',
  random_characters_required: 'Random Characters is required',
  valid_suffix_required: 'Valid Suffix is required',
  format_required: 'Format is required',
  discount_required: 'Discount is required',
  expires_at: 'Expires At',
  always_active: 'Always Active',
  selected_products: 'Selected Products',
  entire_products: 'Entire Products',
  enter_value: 'Enter Value',
  enter_percentage: 'Enter Percentage',
  valid_prefix_required: 'Valid Prefix is required',
  merge_field_required: 'Merge Field is required',
  'Coupon Code Format': 'Coupon Code Format',
  about_discount_coupon: 'About Discount Coupon',
  max_value: 'Max value must be smaller than',
  coupon_name_required: 'Coupon Name is required',
  select_store: 'Select Store',
  store: 'Store',
  store_required: 'Store is required',
  discount_coupons: 'Discount Coupons',
  add_coupon_rule: 'Add Coupon Rule',
  all_apps: 'All Apps',
  add_store: 'Add Store',
  min_value: 'Minimum value must be greater than',
  please_select_store_source: 'Please select a store source',
  store_source_is_required: 'Store source is required',
  edit_store: 'Edit Store',
  stores_and_coupons: 'Stores, Coupon Rules, Coupons and Configuration',
  edit_coupon_rule: 'Edit Coupon Rule',
  create_coupon_rule: 'Create Coupon Rule',
  store_url_is_required: 'Store Url is required',
  applies_to: 'Applies to',
  install: 'Install',
  manage_app: 'MANAGE APP',
  pdf: 'PDF',
  summary: 'Summary',
  apps: 'Apps',
  subscribe_now: 'Subsribe Now',
  selected_plan: 'Selected Plan',
  year: 'Year',
  saving: 'Saving',
  current_plan: 'Current Plan',
  transaction_history: 'Transaction History',
  total_amount: 'Total Amount',
  coupon_list: 'Coupon List',
  coupon_listing: 'Coupon Listing',
  create_coupon: 'Create Coupon',
  store_list: 'Store List',
  you_have_no_store_added:
    'You have no store added. Go ahead and add your Store first.',
  upgrade: 'Upgrade',
  price_starting_from: 'Starting From',
  price: 'Price',
  connection: 'Connection',
  connected: 'Connected',
  not_connected: 'Not Connected',
  disconnect: 'Disconnect',
  change_plan: 'Change Plan',
  active_plan: 'Active Dates',
  merge_field: 'Merge Field',
  prefix_merge_field: 'Prefix Merge Field',
  merge_field_prefix: 'Merge Field Prefix',
  sample: 'Sample',
  search_coupon: 'Search Coupon',
  none: 'None',
  email: 'E-mail',
  delete_portal: 'Delete Portal',
  warning: 'Warning',
  deletePortalWarning:
    'Deleting Portal will cancel all your subscriptions, related with all your apps.',
  unable_to_logout: 'Unable to logout!',
  authorize: 'Authorize',
  about_store: 'About Store',
  automated_coupon_code: 'Automated Coupon',
  trial_expires_on: 'Trial Expires on',
  next_payment_date: 'Next Payment Date',
  limited: 'Limited',
  unlimited: 'Unlimited',
  coupon_usage: 'Coupon Usage',
  specify_number: 'You must specify a number',
  relative: 'Relative',
  no_of_days: 'Number of Days',
  coupon_rule: 'Coupon Rules',
  coupon_rule_listing: 'Coupon Rule Listing',
  coupon_rule_list: 'Coupon Rule List',
  search_coupon_rule: 'Search Coupon Rule',
  coupon_code: 'Coupon Code',
  rule_name: 'Rule Name',
  active_apps: 'Active Apps',
  inactive_apps: 'InActive Apps',
  coupon_rules: 'Coupon Rules',
  cancel_subscription_warning:
    'Are you sure, you want to cancel the subscription ?',
  store_content_line_one:
    'Automated Coupons by MWB is a versatile dynamic coupon generator app that can easily be integrated with your WooCommerce store in just a few clicks. To connect your WooCommerce store with the app, follow the steps below - ',
  store_content_line_two:
    'Select WooCommerce platform from the adjacent dropdown menu.',
  // 'Select your eCommerce platform from the adjacent dropdown menu like WooCommerce.',
  store_content_line_three: 'Add your WooCommerce store URL',
  store_content_line_four: 'Click on Authorize',
  store_content_line_five:
    'Congratulations! The Automated Coupons app is successfully connected with your WooCommerce store. You are now one step closer to generating automated coupons in your store. ',
  coupon_content_line_one:
    'To create or generate coupon codes for your WooCommerce store with the Automated Coupons app, you must consider a certain set of rules for easy managing and monitoring purposes.',
  coupon_content_line_two: 'Set a unique name for each coupon rule',
  coupon_content_line_three:
    'Select the targeted WooCommerce store to list and give away coupons',
  coupon_content_line_four:
    'Add coupon rules to define the format of the coupon code generated. Under the Coupon Code Format, set the values for the fields like prefix, merge field, auto-generated characters, suffix, discount type, coupon value, etc.',
  coupon_content_line_five:
    'Next, add other rules like coupon expiry date, whether coupons are applicable on all products or only on selected products, coupon usage limit, etc. under the section Applies to.',
  coupon_content_line_six:
    'Click on Save. Your coupon codes will be generated over the target source once the set HubSpot workflow enrollment triggers the action.',
  coupon_content_line_seven:
    'Note: All the generated coupons will be listed within the app (Coupons section) and also in your connected WooCommerce store. ',
  total_coupons: 'Total Coupons',
  coupons_used: 'Coupons Used',
  points_and_rewards: 'Loyalty Reward Points',
  rules: 'Rules',
  create_new_rule: 'Create New Rule',
  documentation: 'DOCUMENTATION',
  lets_connect: "LET'S CONNECT",
  points_provided: 'Points provided',
  triggered: 'Triggered',
  rule_type: 'Rule Type',
  display: 'Display',
  Details: 'Details',
  limit: 'Limit',
  only_give_points: 'Only Give Points',
  times_per: 'times per',
  product_field: 'Product Field',
  product_id: 'Product ID',
  week: 'Week',
  points: 'Points',
  select_rule_type: 'Select Rule Type',
  title: 'Title',
  Description: 'Description',
  title_is_required: 'Title is rquired',
  description_is_required: 'Description is rquired',
  rule_type_is_required: 'Rule type is required',
  points_are_required: 'Points are required',
  limit_is_required: 'Limit is required',
  do_you_want_to_delete_this_rule: 'Do you want to delete this rule?',
  yes: 'Yes',
  delete_rule: 'Delete rule',
  rewards: 'Rewards',
  customer: 'Customer',
  activity: 'Activity',
  customer_listing: 'Customer Listing',
  customer_name: 'Customer Name',
  edit_cutsomer: 'Edit Customer',
  search_customer: 'Search Customer',
  history: 'History',
  notes: 'Notes',
  create_new_rewards: 'Create New Rewards',
  edit_reward: 'Edit Reward',
  update_reward: 'Update Reward',
  Code: 'Code',
  claimed_by: 'Claimed By',
  used_at: 'Used in order Id',
  manage_code: 'Manage Code',
  reward_title_required: 'Title is required',
  valid_value_required: 'Valid value is required',
  point_cost: 'Point Cost',
  flat: 'Flat',
  percentage: 'Percentage',
  minimum_spend: 'Minimum Spend',
  enable_coupon_expiration: 'Enable Coupon Expiration',
  days: 'Days',
  cost: 'Cost',
  redeemed: 'Redeemed',
  manage_codes: 'Manage Codes',
  create_new_reward: 'Create New Reward',
  delete_reward: 'Delete Reward',
  do_you_want_to_delete_this_reward: 'Do you want to delete this reward?',
  points_redeem: 'Points Redeem',
  reward: 'Reward',
  delete_customer: 'Delete Customer',
  do_you_want_to_delete_this_customer: 'Do you want to delete this customer?',
  current_points: 'Current Points',
  activities_completed: 'Activities Completed',
  rewards_calimed: 'Rewards Claimed',
  total_revenue: 'Total Revenue',
  referrals: 'Referrals',
  give_points: 'Give Points',
  remove_points: 'Remove Points',
  block: 'Block',
  points_approved_immediately_redeemed_for_rewards:
    'These points will be approved immediately and can be redeemed for rewards.',
  reason: 'Reason',
  reason_is_required: 'Reason is required',
  remove_approve_points_from_customer:
    'You can remove approved points from this customer.',
  dont_remove_points_for_order_returns_refunds_etc:
    'Do not remove points for order returns, refunds etc.',
  removed_by_pointsandreward_automatically:
    'These will be removed by Loyalty Reward Points automatically, removing them here will result in the customer losing double the number of points.',
  points_added_successfully: 'Points added successfully.',
  points_removed_successfully: 'Points removed successfully.',
  block_customer: 'Block Customer',
  block_your_customer_from_loyalty_program:
    'This will block the customer from your loyalty program.',
  blocked_customer_will: 'A blocked customer will',
  no_loger_earn_new_points: 'no longer earn new points',
  and_will: 'and will',
  not_able_to_use_points_they_earned:
    'not be able to use any points they have earned',
  customer_blocked_successfully: 'Customer Blocked Successfully',
  unblock: 'Unblock',
  unblock_customer: 'Unblock Customer',
  unblock_your_customer_from_loyalty_program:
    'This will unblock the customer from your loyalty program.',
  customer_unblocked_successfully: 'Customer unblocked successfully.',
  change_birthday: 'Change Birthday',
  birth_date: 'Birth Date',
  edit_rule: 'Edit Rule',
  store_settings: 'Store Setting',
  coupon_settings: 'Coupon Setting',
  hubspot: 'HubSpot',
  store_currency: 'Store Currency',
  coupon_prefix: 'Coupon Prefix',
  hubspot_owner: 'Hubspot owner',
  properties: 'Properties',
  workflow: 'Workflow',
  show: 'Show',
  Emails: 'Emails',
  hide: 'Hide',
  thank_you_coupon: 'Thank you for creating coupon!',
  store_details: 'Store Details',
  api_key: 'API Key',
  products: 'Products',
  sources: 'Sources',
  pending_points: 'Pending Points',
  approve_pending_points_for_customer: 'Approve Pending Points for Customer',
  by_clicking_approve_pending_points:
    'By Clicking on Approve Button you may approve all the pending points of the customer',
  no_pending_points_available: 'No pending points available',
  widget_settings: 'Widget Settings',
  background_color: 'Background Color',
  position: 'Position',
  is_required: 'is required.',
  widget_position: 'Widget Position',
  app_title: 'App Title',
  primary_color: 'Primary Color',
  text_color: 'Text Color',
  body_background_color: 'Body Background Color',
  heading_color: 'Heading Color',
  body_text_color: 'Body Text Color',
  accent_color: 'Accent Color',
  widget_icon: 'Wiget Icon',
  please_provide_valid_widget_icon: 'Please provide valid widget icon',
  configuration: 'Configuration',
  listing: 'Listing',
  expire_after: 'Expire After',
  interval: 'Interval',
  day: 'Day',
  email_needs_to_be_published_before_emails:
    'Email needs to be published before making workflows.',
  times: 'Times',
  all: 'all',
  approved: 'approved',
  minimum_spend_value_is_required: 'Minimum spend value is required',
  coupon_usage_limit_is_required: 'Coupon usage limit is required',
  count_value_required: 'Count value is required',
  exclude_product: 'Exclude Products',
  config: 'Configuration',
  user_id: 'User Id',
  hubSpotUser: 'HubSpot user',
  something_went_wrong: 'Something went wrong',
  manage_who_can_create_coupons:
    'Manage who can create coupons within HubSpot using CRM cards directly from this panel',
  please_reauthorize: 'Please Re-Authorize your account to access this feature',
  reauthorize_now: 'Re-Authorize now',
  apply_category: 'Apply Category',
  select_category: 'Select Category',
  exclude_category: 'Exclude Category',
  included_product_warning:
    'This product is already included in excluded product list.',
  excluded_product_warning:
    'This product is already included in selected product list.',
  included_category_warning:
    'This category is already included in excluded category list.',
  excluded_category_warning:
    'This Category is already included in selected Category list.',
  you_can_not_exclude_category_message:
    'You can not exclude this category because a selected product belongs to it.',
  you_can_not_select_this_product_message:
    'You can not select this product because its category is already on the excluded category list.',
  category_feature_banner:
    'Create coupons directly from HubSpot contacts — please refer to the',
  setup_guide: 'setup guide',
  enable_new_app_card: 'to enable the new app card feature.',
};

export default en;
